export enum InvestorDetailsControlName {
  IdNumber = 'idNumber',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  EPUAPAddress = 'epuapAddress',
}
